export default "__VITE_ASSET__rpcwsuzh__"